import {observable, action} from "mobx";
import {getCookie} from "../utils/Cookie";

class AppStore {
    @observable showPopup = false;
    @observable showWinPage = false;
    @observable showTrigger = true;

    @observable campaignLoaded = false;
    @observable showTriggerAnimation = true;
    @observable appIsVisible = true;
    triggerTracked = false;


    constructor(){
        this.appIsVisible = !(getCookie('wheel_app_hide') === 'true');
    }
    @action
    stopAnimation = () => {
        this.showTriggerAnimation = false;
    };

    @action
    hideAppForSession = () => {
        this.appIsVisible = false;
        window.sessionStorage.setItem('wheel_app_hided', 'true')
    };

    @action
    hidePopUp = () => {
        this.showPopup = false;
    };

    @action
    hideApp = () => {
        this.showPopup = false;
        this.showWinPage = false;
        this.showTrigger = false;
    }
}

const appStore = new AppStore();
export default appStore;